<i18n>
{
	"en": {
		"header": "Goods types",
		"deleteGoodsType": "Remove goods type | Remove goods types",
		"newGoodsType": "New goods type",
		"icon": "Icon",
		"code": "Code",
		"name": "Name",
		"altName": "Alernative name",
		"minTemp": "Min. temp.",
		"maxTemp": "Max temp.",
		"failedToFetch": "Failed to fetch goods types",
		"failedToUpdateIcon": "Failed to update icon",
		"updatedIcon": "Updated icon"
	},
	"no": {
		"header": "Godstyper",
		"deleteGoodsType": "Slett godstype | Slett godstyper",
		"newGoodsType": "Ny godstype",
		"icon": "Ikon",
		"code": "Kode",
		"name": "Navn",
		"altName": "Alternativt navn",
		"minTemp": "Min. temp.",
		"maxTemp": "Maks temp.",
		"failedToFetch": "Kunne ikke hente godstyper",
		"failedToUpdateIcon": "Kunne ikke oppdatere ikon",
		"updatedIcon": "Ikonet ble oppdatert"
	}
}
</i18n>

<template>
	<t-vertical-panel class="goods-types">
		<div slot="header" class="goods-types-header">
			<t-panel-header size="md" icon="order">
				{{ $t('header') }}
			</t-panel-header>
		</div>
		<div class="goods-types-content">
			<t-grid
				v-if="goodsTypes"
				ref="grid"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinitions"
				:rowHeight="40"
				:items="goodsTypes"
				localStorageId="goodsTypesList"
			>
				<template #iconId="{ item }">
					<t-select
						:selectedItem="item.iconId"
						:items="goodsTypesIcons"
						appearance="minimal"
						relative
						disableBoxShadow
						@select="updateGoodsTypesIcon({goodsType: item, iconId: $event})"
					>
						<template #displayedValue="{ popoverShow }">
							<div class="list-item">
								<t-timpex-icon
									v-if="!item.iconId && item.iconId !== 0 && !popoverShow"
									icon="order"
									color="orange"
								/>
								<t-timpex-icon v-else :icon="getGoodsTypeIcon(item.iconId)" color="neutral" />
							</div>
						</template>
						<template #optionItemValue="{ item }">
							<div class="list-item">
								<t-timpex-icon
									:icon="getGoodsTypeIcon(item)"
									color="neutral"
								/>
							</div>
						</template>
					</t-select>
				</template>
			</t-grid>
			<t-overlay
				:isShown="loading"
				absolute
				loader
			/>
		</div>
	</t-vertical-panel>
</template>

<script>
import { goodsTypesIcons } from '@/core';
import { mapState, mapActions } from './store/goodsTypes.store.js';

export default {
	name: 'GoodsTypes',
	data() {
		return {
			defaultColumnDefinitions: { resizable: true },
			rowsSelected: 0,
			goodsTypesIcons: Object.values(goodsTypesIcons.iconIds),
		};
	},
	computed: {
		...mapState([
			'goodsTypes',
			'loading'
		]),
		columnDefinitions() {
			return [
				{
					field: 'iconId',
					displayName: this.$t('icon'),
					width: 100,
				},
				{
					field: 'tpxCode',
					displayName: this.$t('code'),
					width: 40,
					align: 'center'
				},
				{
					field: 'name',
					displayName: this.$t('name'),
					minWidth: 100
				},
				{
					field: 'alternativeName',
					displayName: this.$t('altName'),
					minWidth: 100
				},
				{
					field: 'minTemperature',
					displayName: this.$t('minTemp'),
					valueGetter: item => item.minTemperature ? `${Math.floor(item.minTemperature)} \u2103` : 'N/A',
					width: 80,
					align: 'right'
				},
				{
					field: 'maxTemperature',
					displayName: this.$t('maxTemp'),
					// change if 0 C is not set as 0.01 C on future types
					valueGetter: item => item.maxTemperature ? `${Math.floor(item.maxTemperature)} \u2103` : 'N/A',
					width: 80,
					align: 'right'
				}
			];
		}
	},
	async mounted() {
		try {
			await this.getGoodsTypes();
		} catch (e) {
			this.$notify({
				type: 'error',
				title: this.$t('failedToFetch')
			});
		}
	},
	methods:{
		...mapActions([
			'getGoodsTypes',
			'setGoodsTypesIcon'
		]),
		getGoodsTypeIcon(iconId) {
			return goodsTypesIcons.getById(iconId);
		},
		async updateGoodsTypesIcon({ goodsType, iconId }) {
			try {
				await this.setGoodsTypesIcon({ goodsType, iconId });
				this.$notify({
					type: 'success',
					title: this.$t('updatedIcon'),
					text: goodsType.name
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToUpdateIcon')
				});
			}
		},
		onRowsSelected(ids) {
			this.rowsSelected = ids.length;
		}
	}
};

</script>

<style lang="scss" scoped>
.goods-types {
	.goods-types-header {
		height: 100%;
		display: flex;
		align-items: center;
		padding-left: 15px;
	}
	.goods-types-sub-header {
		display: flex;
		padding: 0px 15px;
		height: 100%;
		align-items: center;
		justify-content: flex-end;

		> button {
			margin: 10px;
		}
	}
	.goods-types-content {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 5px;
	}
}
.list-item {
	display: flex;
	align-items: center;
	justify-items: flex-start;

	> div {
		margin-left: 10px;
	}
}
</style>
